/**
 * prevent overlapping labels by showing/hiding labels based on a "weight" property
 */
import Labelgun from 'labelgun';

/**
 * uses the "labelgun" library to show or hide marker tooltips based on their "labelWeight" property
 *
 * @param {L.Map} map - Leaflet map instance
 * @param {L.LayerGroup} labelLayers - group of Leaflet map layers
 */
export default function init(map, labelLayers) {
    // labelgun setup
    // @SEE: https://github.com/Geovation/labelgun/blob/9229eeb2a82fded9ba1bfd3260268972f21f4982/docs/examples/leaflet/example.js
    /* eslint-disable no-param-reassign */
    // callback to hide labels
    const hideLabel = (label) => { label.labelObject.style.opacity = 0; };
    // callback to show labels
    const showLabel = (label) => { label.labelObject.style.opacity = 1; };
    // labelgun engine that calls the showing/hiding callback functions
    const labelEngine = new Labelgun(hideLabel, showLabel);

    /**
     * adds a label to the labelgun list for comparison
     *
     * @param {L.Layer} layer - Leaflet map layer object
     * @param {string|number} id - layer identifier (for comparisons)
     */
    function addLabel(layer, id) {
        const toolTip = layer.getTooltip();

        // ignore layers with no tooltip
        if (!toolTip) return;

        // tooltip container element
        const label = toolTip._container;
        if (label) {
            // get the bounding rectangle of the label itself
            const rect = label.getBoundingClientRect();

            // convert the container coordinates (screen space) to Lat/lng
            const bottomLeft = map.containerPointToLatLng([rect.left, rect.bottom]);
            const topRight = map.containerPointToLatLng([rect.right, rect.top]);
            const boundingBox = {
                bottomLeft: [bottomLeft.lng, bottomLeft.lat],
                topRight: [topRight.lng, topRight.lat],
            };

            // higher weight makes a label take precedence over lower weights when they overlap
            const labelWeight = layer.feature.properties.labelWeight || 1;

            // ingest the label into labelgun itself
            labelEngine.ingestLabel(
                boundingBox,
                id,
                labelWeight,
                label,
                String(id), // use the id as the label name; it's not shown anywhere
                false,
            );

            // if the label hasn't been added to the map already
            // add it and set the added flag to true
            if (!layer.added) {
                layer.addTo(map);
                layer.added = true;
            }
        }
    }

    /**
     * re-initializes all label transparencies
     *
     * @param {L.LayerGroup} markers - group of features with tooltips
     */
    function resetLabels(markers) {
        let id = 0;
        markers.eachLayer((label) => {
            addLabel(label, id);
            id += 1;
        });
        labelEngine.update();
    }

    // re-calculate labels on zoom
    map.on('zoomend', () => {
        resetLabels(labelLayers);
    });

    // initial calculation
    resetLabels(labelLayers);
}
